import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import esDict from "@/locales/ec.json";

/**
 * Thank You page. Spanish only per requirements.
 * Located at /thank_you. Back home links to /.
 */
export default function ThankYou() {
  const t = (key) => {
    const parts = key.split(".");
    let cur = esDict;
    for (const p of parts) cur = cur?.[p];
    return cur;
  };

  useEffect(() => {
    document.title = `${t("thankYou.title")} · Ecuproyecta`;
  }, []);

  return (
    <div
      data-testid="thank-you-page"
      className="min-h-screen flex flex-col bg-slate-950 text-slate-100"
    >
      <header className="bg-slate-950 border-b border-slate-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
          <Link
            to="/"
            data-testid="thank-you-logo"
            className="flex items-center gap-2 text-white font-bold tracking-tight text-lg"
          >
            <svg width="28" height="28" viewBox="0 0 32 32" fill="none" aria-hidden="true">
              <rect x="1" y="1" width="30" height="30" rx="7" fill="#0B132B" stroke="#2563EB" strokeWidth="1.5" />
              <path d="M9 22V10h10v2.4h-7.3v2.4h6.6v2.4h-6.6V22H9z" fill="#F9FAFB" />
              <circle cx="23" cy="10" r="1.6" fill="#06B6D4" />
            </svg>
            Ecuproyecta
          </Link>
        </div>
      </header>

      <main className="flex-1 flex items-center">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24 text-center">
          <div className="inline-flex items-center justify-center h-16 w-16 rounded-full bg-blue-600/15 border border-blue-500/40 mb-6">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" className="text-blue-400">
              <polyline points="20 6 9 17 4 12" />
            </svg>
          </div>
          <p className="text-xs font-mono uppercase tracking-widest text-blue-400 mb-3">
            {t("thankYou.eyebrow")}
          </p>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-white tracking-tight">
            {t("thankYou.title")}
          </h1>
          <p className="mt-4 text-lg text-slate-300">
            {t("thankYou.subtitle")}
          </p>
          <p className="mt-4 text-slate-400 leading-relaxed max-w-2xl mx-auto">
            {t("thankYou.body")}
          </p>

          <div className="mt-10 bg-slate-900 border border-slate-800 rounded-xl p-6 text-left max-w-xl mx-auto">
            <h2 className="text-white font-semibold mb-4">
              {t("thankYou.checklistTitle")}
            </h2>
            <ol className="space-y-3">
              {(t("thankYou.checklist") || []).map((item, i) => (
                <li key={i} className="flex items-start gap-3 text-slate-300 text-sm leading-relaxed">
                  <span className="flex-shrink-0 h-6 w-6 rounded-full bg-blue-600 text-white text-xs font-bold flex items-center justify-center">
                    {i + 1}
                  </span>
                  <span>{item}</span>
                </li>
              ))}
            </ol>
          </div>

          <Link
            to="/"
            data-testid="thank-you-back-home"
            className="mt-10 inline-flex items-center justify-center rounded-md bg-blue-600 hover:bg-blue-500 text-white font-semibold px-6 py-3 transition-colors"
          >
            {t("thankYou.backHome")}
          </Link>
        </div>
      </main>

      <footer className="border-t border-slate-800 py-6 text-center text-xs text-slate-500">
        © {new Date().getFullYear()} Ecuproyecta Analítica &amp; Decisiones S.A.S.
      </footer>
    </div>
  );
}
